module.exports = __webpack_public_path__ + "cg.svg?07691c9740ca7674a6f4808a05e19f33";